import React, {useState, useEffect} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';

import {emailSettingsActions, userActions, useSelector} from "inbooma-api";              // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../utils";               // necessary to communicate with inbooma-react
import {_,moment} from "../../../../../vendor";
import SwitchesWide from "./EmailSettingsComponents/SwitchesWide";
import {in_array} from "../../../../utils/Helper";
import showNotification from "../../../helpers/showNotification";

const EmailSettingsView = (props) => {

    // initialize resource - set selected resource or set defaults

    const [initialized, setInitialized] = useState(false);
    const [ownMails, setOwnMails] = useState(null);
    const [userMails, setUserMails] = useState(null);
    const [resourceMails,setResourceMails] = useState(null);
    const [orderMails,setOrderMails] = useState(null);
    const [associates,setAssociates] = useState(null);
    const [setIds, setSetIds] = useState(null);
    const [usedMailTypes,setUsedMailTypes]  = useState(null);
    const [itemState, setItemState] = useState('init');                 // init, saving
    const _user = useSelector(state => state["users_data"].user);
    const _patchUser = useSelector(state => state["users_data"].editUser);
    const _emailSettings = useSelector(state => state["email_settings_data"].emailSettings);
    const [mailTemplates, setMailTemplates] = useState([]);
    const [user, setUser] = useState(null);
    const [mailTemplatePending, setMailTemplatePending] = useState(false);
    const [userPending, setUserPending] = useState(false);
    let createdModifiedText;

    useEffect(() => {
        if(_emailSettings.success === '' || !mailTemplatePending){
            return;
        }
        if(_emailSettings.success === true){
            setMailTemplates(_emailSettings.data);
        }
        setMailTemplatePending(false);
        if(!userPending){
            setInitialized(true);
        }
    }, [_emailSettings]);

    useEffect(() => {
        if(mailTemplatePending || userPending || user === null || mailTemplates.length < 1) return;
        let arrNames = [],
            all = [],
            allUsedTypes = [],
            allSubTypes = [];
        fillArrays(all, allUsedTypes, allSubTypes, arrNames);
        let setIdsArr = [];
        _.each(user.email_settings, function(el){
            setIdsArr.push(el["id"]);
        });
        setSetIds(setIdsArr);
        let associatesArr = {
            owns: allSubTypes['own'],
            users: allSubTypes['user'],
            resources: allSubTypes['resource'],
            orders: allSubTypes['order']
        };

        setUsedMailTypes({
            owns: allUsedTypes['own'],
            users: allUsedTypes['user'],
            resources: allUsedTypes['resource'],
            orders: allUsedTypes['order']
        });
        setAssociates(associatesArr);
        setOwnMails(all['own']);
        setOrderMails(all['order']);
        setUserMails(all['user']);
        setResourceMails(all['resource']);
        let userNbrLabel = (user["role"] === 'user')?t('kunden_nbr'):t('user_nbr');
        let idLabel = (user["role"] === 'user')?user["customer_nbr"]:user["id"];
        let created_printable = moment(user["created"]);
        let modified_printable = moment(user["modified"]);
        createdModifiedText = t('created_at') + ' ' + created_printable.format(' Do MMMM YYYY, HH:mm');
        if(user["modified"] !== null) {
            createdModifiedText += ' | ' + t('last_modified_at') + ' ' + modified_printable.format('Do MMMM YYYY, HH:mm');
        }
        createdModifiedText += " | " + userNbrLabel + ": " + idLabel;
        setInitialized(true);

    }, [mailTemplates, user]);

    useEffect(() => {
        if(_user.success === '' || !userPending){
            return;
        }
        if(_user.success === true){
            setUser(_user.data);
        }
        setUserPending(false);
    }, [_user]);


    useEffect(() => {
       if(initialized || userPending || mailTemplatePending){
           return;
       }
        props.dispatch(userActions.getUser({
            id: (props.params.mailSettingsId !== null?props.params.mailSettingsId:Biscuit.get('user.id')),
            token: Biscuit.get('token')
        }));
       setUserPending(true);
       props.dispatch(emailSettingsActions.getEmailSettings({
           token: Biscuit.get('token')
       }));
        setMailTemplatePending(true);

    }, []);

    const fillArrays = (main, usedTypes, subTypes, arrNames) => {
        _.each(mailTemplates,function(elem){
            let type = elem["type"];
            if(typeof main[type] === 'undefined'){
                main[type] = [];
            }
            if(typeof usedTypes[type] === 'undefined'){
                usedTypes[type] = [];
            }
            if(elem["template"] === 'Order'){
                if( rbac.hasPermission('bookingInfo')) {
                    main[type].push(elem);
                }
            } else if (elem["template"] === 'GroupList'){
                if(rbac.hasPermission('groupList')) {
                    main[type].push(elem);
                }
            } else if (rbac.hasPermission('mailSettings')) {
                if (elem["name"].indexOf('.') >= 0) {
                    let names = elem["name"].split('.');
                    if (!in_array(names[0], usedTypes[type])) {
                        usedTypes[type].push(names[0]);
                    }
                } else {
                    if (elem["name"] === "Report" && Biscuit.get('client.hasGPSLocks') !== 'true'){

                    } else {
                        main[type].push(elem);
                    }
                }

            }
        });

        _.each(mailTemplates,function(elem){
            let type = elem["type"];
            let names = elem["name"].split('.');
            let index = Number(usedTypes[type].indexOf(names[0]));
            let copy = elem;
            if(typeof subTypes[type] === 'undefined'){
                subTypes[type] = [];
            }
            if(arrNames.indexOf(elem["template"]) === -1) {
                copy.subname = "email_setting_get_" + names[1];
                if (typeof subTypes[type][index] !== 'undefined') {
                    subTypes[type][index].push(copy);
                } else {
                    subTypes[type][index] = [copy];
                }
                arrNames.push(elem["template"]);
            }
        });
    }


    useEffect(() => {

        if (_patchUser.success === "" && !userPending) {
            return;
        }

        if (_patchUser.success === true) {
            showNotification('success',_patchUser.data.id);
        }

        if (_patchUser.success === false) {
            showNotification('warning', _patchUser.data.id);
        }

        // close window
        props.dispatch(userActions.editUserResetData())
        abortButtonRef.current.click();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_patchUser]);

    const onSubmit = () => {

        let setEmailSettings = user["email_settings"];
        let setIdsArray = setIds;
        setEmailSettings.forEach(function (val,key){

            if(!in_array(Number(val.id),setIds)){
                setEmailSettings.splice(key, 1);
            } else {
                let index = setIds.indexOf(Number(val.id));
                setIdsArray.splice(index, 1);
            }
        });
        setIdsArray.forEach(function(val){
            setEmailSettings.push({
                id: val
            })
        })
        let userToSave = user;
        userToSave.email_settings = setEmailSettings;
        delete(userToSave["allowedContingents"]);
        delete(userToSave["allowedLocations"]);
        delete(userToSave["allowedPricetariffs"]);
        delete(userToSave["created_by"]);
        props.dispatch(userActions.editUser({
            id: userToSave["id"],
            ...userToSave,
            token: Biscuit.get('token')
        }));

        setUserPending(true);
        //abortButtonRef.current.click();
    };

    const close = () => {
        props.onClose();
    };

    const onChangeType = (e) => {
        let list;
          if(e.currentTarget.checked){
              list = setIds.filter(item => item !== Number(e.currentTarget.name));
              list.push(Number(e.currentTarget.name));
              setSetIds(list)
          } else {
               list = setIds.filter(item => item !== Number(e.currentTarget.name));
              setSetIds(list);
          }
               // set object state
    };



    let user_roles = [
        { label : t('role_user',null,'capital'), value : 'user' },
        { label : t('role_manager',null,'capital'), value : 'manager' },
        { label : t('role_booking-manager',null,'capital'), value : 'booking-manager' },
        { label : t('role_garage-staff',null,'capital'), value : 'garage-staff'},
        { label : t('role_manager-location',null,'capital'), value : 'manager-location'},
        { label : t('role_mediator',null,'capital'), value : 'mediator'},
        // { label : t('role_guide',null,'capital'), value : 'guide'},
        { label : t('role_admin',null,'capital'), value : 'admin'}
    ];
    const abortButtonRef = React.createRef();


    let path = '/dashboard';
    if (document.location.href.indexOf('&path=/users/staff') >= 0) path = '/users/staff';
    else if (document.location.href.indexOf('&path=/users') >= 0) path = '/users';
    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;
    let returnUrl = (typeof props.requestPath !== 'undefined')?props.requestPath + (searchParams.get("role") !== null ? `?role=${searchParams.get("role")}` : '') : path + (searchParams.get("role") !== null ? `?role=${searchParams.get("role")}` : '');
    return (
      <>
          {user !== null && <><div className='js-off-canvas-overlay is-overlay-fixed is-visible'></div>
              <div className="off-canvas position-right is-transition-overlap is-open" id="inb-off-canvas" data-off-canvas="85mrb3-off-canvas" data-close-on-click="false" aria-hidden="false">
              <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
              <h1 className="inb-page-title">{t('email_settings')}</h1>
              <div className="off-canvas__actions column">
          {rbac.hasPermission('mailSettings') &&
              <button type="submit" className={"button medium beautify-" + Biscuit.get('user.client_id') +" button-submit round"} title={t('save')} onClick={onSubmit}>
          {itemState === 'init' &&
              <>
              <i className="fi fi-check"> </i>
              <span>{t('save')}</span>
              </>
          }
          {itemState === 'saving' &&
              <span><img alt="RollingLoader" className="rollingLoader" src={"assets/img/rolling_loader.svg"} />{t('save')}</span>
          }
              </button>
          }
              <a
              href={returnUrl}>
              <button ref={abortButtonRef} type="button" id="inb-resourcesform-abort-button" className="button hollow secondary right button-abort round" title={t('close window')} onClick={close}>
              <i className="fi fi-x"> </i>
              </button>
              </a>
              </div>
              </header>
              <p className="off-canvas__subtitle">
          {createdModifiedText}
              </p>
              <form className="off-content row">
              <div className="inb-form-group column medium-5 small-12 username">
              <label className="inb-form__controlLabel">{t('username')}</label>
              <div className="inb-form__controllClass">
              <input type="text" className="form-control" name="username"
              autoComplete="false" maxLength="255" defaultValue={user["first_name"] + ' ' + user["last_name"]} placeholder="" disabled="disabled" required=""/>
              </div>
              </div>

              <div className="inb-form-group column medium-5 small-12 role"><label className="inb-form__controlLabel">
          {t('user_role',null,'capital')}</label>
              <div className="inb-form__controllClass">
              <select className="form-control " name="role" defaultValue={user["role"]} disabled="disabled" required="">
          {user_roles.map(userData => {
              return(
              <option key={userData.value} value={userData.value}>{userData.label}</option>
              )
          })}
              </select>
              </div>
              </div>

          {((ownMails !== null && ownMails.length >0) || (associates !== null && associates["owns"].length > 0)) &&
              <>
              <SwitchesWide
              mails={ownMails}
              type="owns"
              associates={associates["owns"]}
              setIds={setIds}
              onChangeType={onChangeType}
              usedMailTypes={usedMailTypes["owns"]}
              in_array={in_array}
              />
              </>
          }
          {rbac.hasPermission('mailSettings') &&
              <>
          {((orderMails !== null && orderMails.length >0) || (associates !== null && associates["orders"].length > 0)) &&
              <>
              <SwitchesWide
              mails={orderMails}
              type="orders"
              associates={associates["orders"]}
              setIds={setIds}
              onChangeType={onChangeType}
              usedMailTypes={usedMailTypes["orders"]}
              in_array={in_array}
              />
              </>
          }
          {((userMails !== null && userMails.length >0) || (associates !== null && associates["users"].length > 0)) &&
              <>
              <SwitchesWide
              mails={userMails}
              type="users"
              associates={associates["users"]}
              setIds={setIds}
              onChangeType={onChangeType}
              usedMailTypes={usedMailTypes["users"]}
              in_array={in_array}
              />
              </>
          }
          {Biscuit.get('client.hasResources') === 'true' && ((resourceMails !== null && resourceMails.length >0) || (associates !== null && associates["resources"].length > 0)) &&
              <>
              <SwitchesWide
              mails={resourceMails}
              type="resources"
              associates={associates["resources"]}
              setIds={setIds}
              onChangeType={onChangeType}
              usedMailTypes={usedMailTypes["resources"]}
              in_array={in_array}
              />
              </>
          }
              </>}
              </form>
              </div></>
          }
      </>
    );
};

export default EmailSettingsView;